import type { UserInfoType } from '../api/fetchers/userInfo/types';
import type { ChipValueType, ChipWeights } from '../store/slices/chips/types';

// Finds the largest chip based on the available balance
export const selectMaxAffordableChip = (
  chips: ChipValueType[],
  selectedChip: ChipValueType,
  userInfo: UserInfoType | null,
  totalBet: number = 0
): ChipValueType => {
  const balance = userInfo?.balance.amount ?? 0;
  const bonus = userInfo?.balance.bonus ?? 0;
  const availableBalance = balance + bonus - totalBet;
  const shouldShiftChip = selectedChip.value > availableBalance; // condition to shift active chip left

  if (shouldShiftChip) {
    for (let i = chips.length - 1; i >= 0; i--) {
      if (availableBalance >= chips[i].value) {
        return chips[i];
      }
    }
    return chips[0]; // return the smallest chip if none of the chips are affordable
  } else {
    return selectedChip;
  }
};

export const getChipIndexFromWeight = (weight: ChipWeights): number => weight - 1;

export const getChipWeightFromIndex = (index: number): ChipWeights => (index + 1) as ChipWeights;
